import * as React from 'react'
import { styled } from '../../../../shared/styled-components'
import { NewOfficeList } from './NewOfficeList'
import { Utils } from '../../../../shared/Utils'
import { OfficeInstance } from '../../../../models/Office'

interface IProps {
  loading?: boolean
  offices: OfficeInstance[]
  onLoadMore?: () => any
  onVideoOpen?: (office: OfficeInstance) => any
}

export const OfficeListBox = ({ loading, offices, onLoadMore, onVideoOpen }: IProps) => {
  return (
    <Container>
      <Header>
        <SearchIcon src={Utils.getAssetPath('/assets/calculator/result/search.svg')} />
        <Headline>
          Beratungstermin bei einem <Specialist>Spezialisten</Specialist> vereinbaren
        </Headline>
      </Header>

      <Text>
        Unsere Partnerpraxen erüllen eine Reihe von strengen Qualitätsrichtlinien, die sicherstellen, dass Sie von einem
        Experten in der dentalen Implantologie behandelt werden, wenn Sie eine unserer Partnerpraxen aufsuchen!
        Vereinbaren Sie jetzt ganz einfach online einen unverbindlichen beratungstermin in einer unserer
        implacheck®-Partnerpraxen!
      </Text>

      <NewOfficeList {...{ loading, offices }} trackingSource="calculator" onVideoClick={onVideoOpen} />
      <LoadMoreButton onClick={onLoadMore}>
        Weitere Spezialisten anzeigen
        <Caret src={Utils.getAssetPath('/assets/calculator/result/arrow-down.svg')} />
      </LoadMoreButton>
    </Container>
  )
}

const Container = styled.div`
  background: ${(props) => props.theme.blueColor};
  padding: 30px;
  display: flex;
  flex-direction: column;
  color: white;
  border-radius: 10px;
  background-image: url(${Utils.getAssetPath('https://implacheck.de/img/big-bg-endcard-implantatkostenrechner.jpg')});
  @media (max-width: 950px) {
    border-radius: 0;
    background-position: -10px;
  }
  @media (max-width: 600px) {
    padding: 0px;
    background-image: none;
    background-color: white;
    }
    @media print { 
  -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;                 /* Firefox 48 – 96 */
    print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
    padding-bottom: 20px;  
   }
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
   @media (max-width: 600px) {
   background-color: ${(props) => props.theme.DarkblueColor};
   }
`

const Headline = styled.h2`
  font-size: 20px;
  color: white;
   @media (max-width: 600px) { 
   padding: 10px 20px;
   color: white;
   background-color: rgba(28, 37, 65, 1);
   }
`

const Specialist = styled.span`
  color: ${(props) => props.theme.greenColor};
`

const Text = styled.div`
  font-size: 12px;
  padding: 10px 20px 20px 20px;
   @media (max-width: 600px) {
  color: rgba(28, 37, 65, 1);
  }
`

const LoadMoreButton = styled.button`
  text-align: center;
  background: white;
  color: ${(props) => props.theme.blueColor};
  width: 50%;
  margin: 0 auto;
  padding: 16px 20px;
  border-radius: 10px;
  border: 0;
  @media (max-width: 600px) {
    width: calc(100% - 20px);
    margin-top: 20px;
    background-color: rgba(28, 37, 65, 1);
    color: white;
    margin-bottom: 20px;
   }
   @media print { 
  display: none;
  }
`

const SearchIcon = styled.img`
  margin-right: 0.5rem;
  @media (max-width: 600px) {
    display: none;
  }
`

const Caret = styled.img`
  margin-left: 1rem;
  height: 0.8rem;
`
